/** Visible "Questions people ask" on `/method` (rendered as h3 + paragraph) and its FAQPage JSON-LD. */
export type MethodPageFaqItem = {
  question: string;
  answer: string;
};

export const METHOD_PAGE_FAQ_ITEMS: MethodPageFaqItem[] = [
  {
    question: 'Where does the data come from?',
    answer:
      'Open internet data, open databases, and market prices from Twelve Data. Nothing private, nothing you could not look up yourself.',
  },
  {
    question: 'Who picks the holdings?',
    answer:
      'The AI picks the holdings and how much goes in each. A person checks every reason before anything is held.',
  },
  {
    question: 'What does an idea have to pass?',
    answer:
      'Three tests, on years the model never trained on: it has to predict across the whole market, beat the S&P 500 after fees, and beat simply buying the biggest companies.',
  },
  {
    question: 'How often does it change?',
    answer:
      'Once a year, on a date set ahead. The model portfolio was formed on 1 Oct 2024 and re-picked on 1 Oct 2025. It is not a daily tip feed.',
  },
  {
    question: 'Do you show the weeks you lose?',
    answer:
      'Yes. Every week is marked against the S&P 500 at total return, and the weeks that trail stay in the series.',
  },
];
